module.exports = "/_next/static/images/fancy-473f07dafca279ff673bfe47e94b80de.png";